<template>
  <div class="lb">
    <div ref="barMian" class="barMian"></div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.scope94",
  props: {
    vdata: {
      type: [Array, String],
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: "scope94-【组件】双柱图",
      timer: null,
      defaultdata: [
        {
          value2: "数据一",
          value3: "系列一",
          value4: "28",
          value5: "系列二",
          value6: "14",
        },
        {
          value2: "数据二",
          value3: "系列一",
          value4: "21",
          value5: "系列二",
          value6: "14",
        },
        {
          value2: "数据三",
          value3: "系列一",
          value4: "31",
          value5: "系列二",
          value6: "14",
        },
        {
          value2: "数据四",
          value3: "系列一",
          value4: "28",
          value5: "系列二",
          value6: "14",
        },
        {
          value2: "数据五",
          value3: "系列一",
          value4: "21",
          value5: "系列二",
          value6: "14",
        },
      ],
      valueMap: [
        { name: "名称", key: "value2" },
        { name: "柱状图一图例", key: "value3" },
        { name: "柱状图一数据", key: "value4" },
        { name: "柱状图二图例", key: "value5" },
        { name: "柱状图二数据", key: "value6" },
        // { name: "单位", key: "value7" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n.filter(
          (item) => item && item[this.valueMap[0].key]
        );
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
    defaultdata(n) {
      this.DrawEcharts();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    ...methods,
    DrawEcharts() {
      clearInterval(this.timer);
      this.timer = null;
      var echarts = require("echarts");
      var TmyChart = echarts.init(this.$refs.barMian);
      let data1 = [];
      let data2 = [];
      let legend = [];
      let vdata = JSON.parse(JSON.stringify(this.defaultdata));
      let xData = [...new Set(vdata.map((item) => item.value2))];
      let xData2 = [...new Set(vdata.map((item) => item.value1))];
      let chartlist = xData2.map((item) => {
        let list = vdata.filter((del) => del.value1 == item);
        return { name: item, data: list };
      });
      chartlist[0].data.forEach((item, i) => {
        if (item.value3 && item.value4) {
          const vdata1 = { name: item.value2, value: item.value4 };
          data1.push(vdata1);
        }
        if (item.value5 && item.value6) {
          const vdata2 = { name: item.value2, value: item.value6 };
          data2.push(vdata2);
        }
        if (i == 0) {
          if (item.value3) {
            legend.push({
              show: true,
              top: "2%",
              right: "50%",
              itemHeight: 12, //图例的高度  文字左边那个
              itemWidth: 10,
              icon: "rect",
              textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
              data: [item.value3 || ""],
            });
          }
          if (item.value5) {
            legend.push({
              show: true,
              top: "2%",
              left: "50%",
              itemHeight: 12, //图例的高度  文字左边那个
              itemWidth: 10,
              icon: "rect",
              textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
              data: [item.value5 || ""],
            });
          }
        }
      });
      const percent = (7 / xData.length) * 100;
      let zoom = [
        {
          id: "scope94", // 唯一的id
          type: 'slider',
					moveHandleSize: 0,
					showDetail: false, //关闭：拖拽时候显示详细数值信息。	
          dataBackground: {
						show: false,
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					selectedDataBackground: {
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
          backgroundColor: "transparent",
          fillerColor:"rgba(0,0,0,.2)",
          borderColor:"transparent",
          start: 0,
          brushSelect: false,
          end: percent
        },
      ];
      var Toption = {
        tooltip: {
          trigger: "axis",
        },
        legend: [...legend],
        grid: {
          left: "5px",
          right: "10px",
          bottom: "0px",
          top: "40px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: xData,
          axisLabel: {
            interval: 0,
            width: 50,
            overflow: 'truncate', //文字超出宽度截断，默认为...
            overflow: "truncate", //文字超出宽度截断 换行
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
              fontSize: "14",
              lineHeight: 16,
            },
          },
          axisLine: {
            lineStyle: {
              // X 轴颜色配置
              color: "#4792e9",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          splitNumber: 4, // 设置y轴刻度间隔个数
          axisLabel: {
            textStyle: {
              color: "#979AA0", // 这里将 x 轴文本颜色设为灰白色
            },
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "rgba(231,241,251,.2)",
            },
          },
        },
        series: [
          {
            data: data1,
            type: "bar",
            name: vdata[0].value3 || "",
            barWidth: 15,
            barGap: "40%",
            label: {
              normal: {
                show: true,
                position: "top",
                color: "#0182fc",
              },
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "#0182fc", // 0% 处的颜色
                  },
                  {
                    offset: 0.8,
                    color: "#0182fc", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#08315f", // 100% 处的颜色
                  },
                ],
                false
              ),
            },
          },
          {
            data: data2,
            type: "bar",
            name: vdata[0].value5 || "",
            barWidth: 15,
            label: {
              normal: {
                show: true,
                position: "top",
                color: "#00e3e2",
              },
            },
            barGap: "40%",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "#00e3e2", // 0% 处的颜色
                  },
                  {
                    offset: 0.8,
                    color: "#00cbcc", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#023742", // 100% 处的颜色
                  },
                ],
                false
              ),
            },
          },
        ],
        dataZoom: xData.length > 7 ? zoom : [],
        // animationDuration: 0,
        // animationDurationUpdate: 3000,
        // animationEasing: "linear",
        // animationEasingUpdate: "linear",
      };
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(() => {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
      
   
    },
  },
  created() {},
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata;
    }
    this.setData(); //需要刷新的数据
    this.DrawEcharts();
  },
};
</script>

<style scoped>
.lb {
  width: 435px;
  height: 240px;
  display: flex;
  position: relative;
  padding: 10px 0;
}

.barMian {
  width: 100%;
  height: 100%;
}
</style>
